
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36","viewBox":"0 0 9.525 9.525","version":"1.1","id":"svg6813"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',{attrs:{"id":"defs6807"}}),_c('g',{attrs:{"id":"layer1","transform":"translate(0 -287.475)"}},[_c('g',{attrs:{"id":"g6873"}},[_c('g',{attrs:{"transform":"translate(-116.885 304.365)","id":"g6864"}},[_c('g',{attrs:{"id":"g6856","transform":"matrix(.98744 0 0 .98809 1.468 -.088)"}},[_c('g',{attrs:{"id":"krest","transform":"matrix(.26458 0 0 .26458 116.885 -17.049)"}},[_c('ellipse',{attrs:{"id":"Ellipse_1197","data-name":"Ellipse 1197","cx":"18.229","cy":"18.217","rx":"18.229","ry":"18.217","transform":"translate(0 .168)","fill":"#f66d6d"}}),_c('g',{attrs:{"id":"Group_8116","data-name":"Group 8116","transform":"rotate(135 12.498 15.947)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Rectangle_6150","data-name":"Rectangle 6150","transform":"translate(8.175)","fill":"#fff","d":"M0 0h3.987v20.342H0z"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Rectangle_6151","data-name":"Rectangle 6151","transform":"translate(0 8.174)","fill":"#fff","d":"M0 0h20.342v3.987H0z"}})])])])])])])])
          )
        }
      }
    